import { LogosURLsContext } from '@shared/contexts/pluginContexts/LogosURLsContext';

type StandardLogosContextProviderProps = {
  children: JSX.Element;
};
export const StandardLogosContextProvider = ({
  children,
}: StandardLogosContextProviderProps) => {
  const logos = {
    ALJEX: '/aljex-loadboard.png',
    TRIUMPH: '/triumph.png',
    DAT: '/dat.png',
    DRAYRATES: '/drayrates.jpeg',
    DTS: '/dts.png',
    SUNSET: '/sunset.png',
    TABI: '/tabi.png',
    WERNER: '/werner.png',
    ARCBEST: '/arcbest.png',
    ECHO: '/echo.png',
    TRANSFIX: '/transfix.png',
    BITFREIGHTER: '/bitfreighter.png',
    WWEX: '/wwex.png',
    FASTMORE: '/fastmore.jpeg',
    WORLDWIDE_LOGISTICS: '/worldwide-logistics.png',
    AVRL: '/avrl.jpeg',
    CUSTOM: '/logo.png',
    HOSTED_MCLEOD: '/mcleod.png',
    TRUCKSTOP: '/truckstop.png',
    NTG: '/ntg.png',
    SONAR: '/sonar.jpeg',
    TURVO: '/turvo-text.png',
    REVENOVA: '/revenova.png',
    SOFTMODAL: '/softmodal.png',
  };

  return (
    <LogosURLsContext.Provider
      value={{
        logos,
      }}
    >
      {children}
    </LogosURLsContext.Provider>
  );
};
